import React, { useState } from 'react';
import { OfferCard } from 'types';
import {
    Container,
    CardInner,
    CardFront,
    CardBack,
    IconContainer,
    Title,
    Subtitle,
    List,
    ListItem,
    CardHoverBg,
    RotateIcon,
    Disclaimer,
} from './styled';

export interface AllianceCardProps {
    config: OfferCard;
}

export const AllianceCard: React.FC<AllianceCardProps> = ({
    config: {
        back: { description, items, title, disclaimer },
        front,
        icon,
        gradient,
    },
}): JSX.Element => {
    const [isFlipped, setIsFlipped] = useState(false);

    return (
        <Container onClick={() => setIsFlipped(!isFlipped)}>
            <CardInner $isFlipped={isFlipped}>
                <CardFront styles={{ background: gradient }}>
                    <CardHoverBg />
                    <IconContainer>
                        {icon}

                        <RotateIcon name={'Rotate'} size={47} />
                    </IconContainer>
                    <Title front>{front}</Title>
                </CardFront>
                <CardBack gradient={gradient}>
                    {title && <Title>{title}</Title>}
                    {description && <Subtitle>{description}</Subtitle>}
                    {items && (
                        <List>
                            {items.map((item, index) => (
                                <ListItem
                                    key={index}
                                    dangerouslySetInnerHTML={{
                                        __html: item,
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                />
                            ))}
                        </List>
                    )}
                    {disclaimer && <Disclaimer>{disclaimer}</Disclaimer>}
                </CardBack>
            </CardInner>
        </Container>
    );
};

export default AllianceCard;
